import React from 'react';
import '../../../../styles/fight/challenger/BaseFloatingModal.scss';

const BaseFloatingModal = ({ icon, boldText, subText, isOpen, onClose }) => {
  return (
    isOpen && (
      <div
        className='floating-modal-overlay'
        tabIndex='0'
        onKeyDown={e => e.key === 'Enter' && onClose()}
        role='button'
        onClick={onClose}>
        <div
          className='floating-modal'
          tabIndex='0'
          onKeyDown={e => e.stopPropagation()}
          role='button'
          onClick={e => e.stopPropagation()}>
          <div className='icon-container'>{icon}</div>
          <p className='bolded-text'>{boldText}</p>
          <p className='sub-text'>{subText}</p>
        </div>
      </div>
    )
  );
};

export default BaseFloatingModal;
